import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
import { getUpgradeRecommendationQueryFn } from './queries/get-upgrade-recommendation.query';
export const UpgradeRecommendationQueriesConfig = createQueriesConfig({
  getUpgradeRecommendation: {
    queryFn: getUpgradeRecommendationQueryFn
  }
});
//# sourceMappingURL=upgrade-recommendation.queries.js.map